import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { ShippingCompany } from "@/types/shipping-company";

export const useFetchShippingCompanies = () => {
  return useQuery({
    queryKey: ['shipping-companies'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('shipping_companies')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data as ShippingCompany[];
    },
  });
};